// extracted by mini-css-extract-plugin
module.exports = {"internalContainer":"SearchBodyContainer_internalContainer__Yb3_Y"};